<script lang="ts">
  import type { Alternative } from '@pin/schemas/client-state-response';
  import AlternativeItem from './AlternativeItem.svelte';
  import AlternativeList from './AlternativeList.svelte';
  import { onMount } from 'svelte';
  import { userPrefersReducedMotion } from '@pin/dom-utils';

  export let alternatives: Alternative[];
  export let votes: string[];

  const getAlternatives = (alternatives: Alternative[], votes: string[]) => {
    const voteMap: Record<string, number> = {};
    votes.forEach((vote) => {
      voteMap[vote] = voteMap[vote] ? voteMap[vote] + 1 : 1;
    });

    return alternatives
      .filter((alternative) => voteMap[alternative.id])
      .sort((a, b) => voteMap[b.id] - voteMap[a.id]);
  };

  $: alternatives = getAlternatives(alternatives, votes);

  onMount(() => {
    const behavior = userPrefersReducedMotion() ? 'auto' : 'smooth';
    window.scrollTo({
      top: 0,
      behavior,
    });
  });
</script>

<AlternativeList>
  {#each alternatives as alternative}
    <AlternativeItem {alternative} {votes} submitted />
  {/each}
</AlternativeList>
